import { useEffect, useState } from 'react';
import { showActiveBrandSections } from '@/components/customercenter-ui/utils/assetSaleUtils';
import { useProjSettings } from '@/frontastic/hooks/useProjectSettings/useProjectSettings';
import { COOKIE_KEYS } from '../../../constants/constant';

function getCookieValue(key: string): string | null {
  if (typeof document === 'undefined') return null;
  const cookies = document.cookie.split('; ');
  const cookie = cookies.find((cookie) => cookie.startsWith(key + '='));
  return cookie?.split('=')[1] ? decodeURIComponent(cookie.split('=')[1]) : null;
}

function getSelectedDivision(): string | null {
  const currentSite = getCookieValue(COOKIE_KEYS?.selectedSite);
  return currentSite?.slice(0, 2) ?? null;
}

export const useShowActiveBrandSection = () => {
  const projectSettings = useProjSettings();
  const [showActiveBrandSection, setShowActiveBrandSection] = useState(false);

  useEffect(() => {
    const divisionCode = getSelectedDivision();
    const result = showActiveBrandSections(projectSettings, divisionCode ?? '');
    setShowActiveBrandSection(result);
  }, [projectSettings]);

  return showActiveBrandSection;
};
